import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import { DIMMING } from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';
import PropertyPicker from './components/PropertyPicker';

class Dimming extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            dimmingEnabled: this.props.properties[DIMMING.enableAnalogDimming].value === "1" ? true : false,
            dimmingCurve: this.props.properties[DIMMING.dimmingCurve].value,
            dimmingCurveValues: this.props.properties[DIMMING.dimmingCurve].valueMeta.availableValues,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);
    }

    render() {

        return (
            <><Row>
                <Col sm={3}>
                    <Card className="card-feature-component" style={{'width': '100%'}} >
                        <div className="card-header-feature">
                            {'Dimming'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertySwitch
                                property={this.props.properties[DIMMING.enableAnalogDimming]}
                                title={this.props.properties[DIMMING.enableAnalogDimming].info.displayName}
                                handleChange={this.handleChange} />

                            <PropertyDropdown
                                disabled={this.props.properties[DIMMING.enableAnalogDimming].value === '1' ? false : true}
                                property={this.props.properties[DIMMING.dimmingCurve]}
                                properties={this.state.dimmingCurveValues}
                                title={this.props.properties[DIMMING.dimmingCurve].info.displayName}
                                titleSize={6}
                                dropdownStyle={{ display: 'flex', justifyContent: 'flex-end'}}
                                dropdownSize={6}
                                handleChange={this.handleChange} />

                            <PropertyPicker
                                disabled={this.props.properties[DIMMING.enableAnalogDimming].value === '1' ? false : true}
                                property={this.props.properties[DIMMING.dimmingMin]}
                                title={this.props.properties[DIMMING.dimmingMin].info.displayName + " (" +this.props.properties[DIMMING.dimmingMin].info.unit +")"}
                                margin="0.75rem auto"
                                // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                min={this.props.properties[DIMMING.dimmingMin].valueMeta.min}
                                max={this.props.properties[DIMMING.dimmingMin].valueMeta.max}
                                inputStyle={{ padding: "0", maxWidth: "auto" }}
                                titleSize={6}
                                inputSize={6}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </Col>

                <Col sm={3}>
                    <Card className={super.getClassName(this.props.properties)} style={{width: '100%'}}>
                        <div className="card-header-feature">
                            {'Architectural Features'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={this.props.properties[DIMMING.longSoftStart]}
                                title={this.props.properties[DIMMING.longSoftStart].info.displayName}
                                handleChange={this.handleChange} />
                            <PropertySwitch
                                property={this.props.properties[DIMMING.dimToZero]}
                                title={this.props.properties[DIMMING.dimToZero].info.displayName}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(Dimming);
